import Typography from "@mui/material/Typography";
import {Box} from "@mui/material";

export default function Rules () {

    return (
        <Box
            sx={{
                "& br": {
                    content: `" "`,
                    display: "block",
                },
                "& p": {
                    mb: 5,
                    textAlign: 'justify',
                    lineHeight: 1.8
                },
            }}
        >
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۱- تعاریف
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                مطابق قانون تجارت الکترونیک وبه منظور شفاف سازی اطلاعات و برداشت
                مشترک از واژه‌های به کار رفته در توافقات ذیل الذکر، تعاریف کلمات
                مندرج در متن قوانین به شرح زیر تعریف می شوند.
                <br />
                ۱-۱- فروشگاه: فروشگاه اینترنتی پیکان پارس به عنوان فروشنده
                <br />
                ۲-۱- سایت: وب سایت فروشگاه اینترنتی پیکان پارس به آدرس
                www.paykanpars.com
                <br />
                ۳-۱- محتوای سایت: کلیه اطلاعات من‌جمله قیمت، متن، عکس، فیلم و
                مشخصات فنی قطعات یا کلیه مقالات و اخبار درج شده در سایت و .... .
                <br />
                ۴-۱- کاربر میهمان: هر فردی که از طریق اینترنت وارد سایت پیکان پارس
                شده باشد، کاربر میهمان تلقی می شود.
                <br />
                ۵-۱- عضو: هر شخص حقیقی که بنا بر مشخصات هویتی قابل استناد به عضویت
                سایت درآمده باشد، عضو تلقی می شود.
                <br />
                ۶-۱- مشتری: کاربر یا عضوی که از سایت خرید می نماید.
                <br />
                ۷-۱- سفارش: کالا یا کالاهایی که مشتری انتخاب و با تکمیل فرآیند
                سفارش گذاری در سایت ، قصد خرید آنها را اعلام می نماید.
                <br />
                ۸-۱- استعلام: ارسال سفارش از طرف مشتری برای بررسی موجود بودن در
                لحظه کالاهای سفارش داده شده و بررسی تغییر قیمت احتمالی
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۲- شرایط انعقاد بیع برای خرید از سایت
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                مشابه محیط فیزیکی، در محیط الکترونیکی نیز هر گونه داد و ستدی که
                انجام می گیرد، نشان دهنده وقوع یک عقد یا قرارداد می باشد. عقد یا
                قرارداد مطابق ماده ۱۸۳{" "}
                <a href="https://faradeed.ir/fa/news/45573/%D9%85%D8%AA%D9%86-%DA%A9%D8%A7%D9%85%D9%84-%D9%82%D8%A7%D9%86%D9%88%D9%86-%D9%85%D8%AF%D9%86%DB%8C">
                    قانون مدنی
                </a>{" "}
                عبارتست از اینکه ” یک یا چند نفر در مقابل یک یا چند نفر دیگر تعهد
                بر امری نمایند و مورد قبول آنها باشد ” ؛ بر همین اساس قرارداد
                آنلاین نیز قراردادی است که از طریق “داده پیام” منعقد می گردد.
                <br />
                ثبت هر گونه سفارش به منزله آگاهی و قبول قوانین سایت بوده و لذا
                مشتری موظف است قبل از هر گونه ثبت سفارش این قوانین را به دقت
                مطالعه و در صورتیکه با آنها موافق است، سفارش خود را ثبت نماید.
                <br />
                سن کاربران: برای خرید از سایت سن قانونی (۱۸ سال تمام) الزامی بوده
                و در غیر اینصورت می بایست خرید از سایت توسط والدین یا قیم قانونی
                انجام شود . عدم رعایت این امر راسا بر عهده مشتری خواهد بود.
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۳- راه های ارتباط الکترونیکی سایت
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                هنگامی که شما از سرویس‌‏ها و خدمات پیکان پارس استفاده می‏‌کنید،
                سفارش اینترنتی خود را ثبت یا خرید می‏‌کنید و یا به پیکان پارس
                ایمیل می‏‌زنید، این ارتباطات به صورت الکترونیکی انجام می‏‌شود و در
                صورتی که درخواست شما با رعایت کلیه اصول و رویه‏‌ها باشد، شما
                موافقت می‌‏کنید که پیکان پارس به صورت الکترونیکی (از طریق پست
                الکترونیکی، سرویس پیام کوتاه و سایر سرویس‌های الکترونیکی) به
                درخواست شما پاسخ دهد.
                <br />
                جهت اطلاع‌رسانی رویدادها، خدمات و سرویس‌های ویژه ، امکان دارد
                پیکان پارس برای اعضای وب سایت ایمیل یا پیامک ارسال نماید که در
                صورت عدم تمایل ایشان با ارسال .... این سرویس لغو می گردد.
                <br />
                توجه فرمایید تنها مرجع رسمی مورد تایید ما برای ارتباط با شما،
                پایگاه رسمی این سایت یعنی www.paykanpars.com است. ما با هیچ روش
                دیگری جز ارسال نامه از طرف آدرس‏‌های رسمی و تایید شده در سایت، با
                شما تماس نمی‌‏گیریم. وب سایت پیکان پارس هیچگونه سایت اینترنتی با
                آدرسی غیر از www.paykanpars.com و همچنین، هیچ گونه وبلاگ و شناسه
                در برنامه‏‌های گفتگوی اینترنتی و غیره ندارد و هیچ ‏گاه با این
                روش‏‌ها با شما تماس نمی‏‌گیرد. کاربران جهت برقراری ارتباط، تنها
                می‏‌توانند از آدرس‌‏های ذکر شده در بخش ارتباط با ما استفاده کنند
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۴- مراحل ثبت سفارش و خرید
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                ۱-۴- ثبت سفارش و استعلام: با توجه به آنکه موجودی کالاهای سایت و
                قیمتها در طول زمان در حال تغییر می باشند، برای انجام خرید ابتدا
                لازمست مشتریان استعلام قیمت و موجودی نمایند.
                <br />
                ۲-۴- پاسخ استعلام و نهایی کردن سفارش: بطور معمول و در روز کاری و
                ساعات اداری حداکثر 4 ساعت پس از ثبت سفارش، پاسخ استعلام و مهلت
                زمانی برای تکمیل سفارش برای مشتریان ارسال می گردد. پس از آن
                مشتریان فرصت خواهند داشت تا در مهلت مقرر سفارش خود را تکمیل و
                نهایی نمایند. چنانچه مشتریان در مهلت مشخص شده سفارش خود را نهایی
                نفرمایند، سفارش آنها ناتمام تلقی شده و دیگر امکان نهایی کردن آن را
                نخواهند داشت. در این موارد چنانچه مشتری تقاضای فعالسازی مجدد سفارش
                را داشته باشد و کماکان امکان ارسال کالا وجود داشته باشد، مجددا
                مهلت تکمیل به مشتری داده خواهد شد.
                <br />
                ۳-۴- کاربران و مشتریان محترم برای مشاهده، دریافت اطلاعات و حتی ثبت
                سفارش ملزم به ثبت نام در سایت می باشند. با ثبت این اطلاعات،
                کاربران و مشتریان ضمن اطمینان از محفوظ بودن اطلاعات خود نزد سایت،
                به سایت اختیار می دهند تا از این اطلاعات جهت برقراری ارتباط
                استفاده نماید.
                <br />
                ۴-۴- مشتریان در هنگام ثبت سفارش می بایست اطلاعات خود را دقیق وارد
                فرم سفارش نمایند، در غیراینصورت مسئولیت بروز هر گونه مشکل و ضرر و
                زیان احتمالی بر عهده ایشان می باشد. بنابراین درج آدرس، ایمیل و
                شماره تماس‌های همراه و ثابت توسط مشتری، به منزله مورد تایید بودن
                صحت آنها است و در صورتی که این موارد به صورت صحیح یا کامل درج نشده
                باشد، پیکان پارس جهت اطمینان از صحت و قطعیت ثبت سفارش می‌تواند از
                مشتری، اطلاعات تکمیلی و بیشتری درخواست کند .همچنین، مشتریان
                می‌توانند نام، آدرس و تلفن شخص دیگری را برای تحویل گرفتن سفارش
                وارد کنند و اگر مبلغ سفارش از پیش پرداخت شده باشد، تحویل گیرنده
                سفارش هنگام دریافت کالا باید کارت شناسایی معتبر ارائه نماید.
                همچنین آدرسی که خریدار به عنوان آدرس تحویل‌گیرنده ثبت یا انتخاب
                می‌کند، در فاکتور درج خواهد شد.
                <br />
                ۵-۴- روز کاری به معنی روز شنبه تا پنج شنبه هر هفته، به استثنای
                تعطیلات عمومی در ایران است و کلیه سفارش‏‌های ثبت شده در طول روزهای
                کاری و اولین روز پس از تعطیلات بررسی و اعلام موجودی می‌‏شوند. لازم
                به ذکر است ثبت سفارش در پیکان پارس در کل ایام سال اعم از تعطیلات
                رسمی نیز امکان پذیر می باشد.
                <br />
                ۶-۴- کلیه سفارش‌‏های ثبت شده در سایت پیکان پارس به وسیله ارسال کد
                سفارش مندرج در پیش فاکتور سیستمی از طریق ...... ، در پروسه بررسی
                قرار میگیرند. خرید شما از پیکان پارس برای ما افتخار است و تیم
                پیکان پارس سعی خود را در تحویل کالا خریداری شده مشتریان انجام
                خواهد داد اما چنانچه موجودی کالا در پیکان پارس حتی پس از اقدام
                مشتری به سفارش‌‏گذاری به پایان برسد. حق کنسل کردن آن سفارش و یا
                استرداد وجه سفارش برای پیکان پارس محفوظ است و یا مشتری می‏‌تواند
                به جای کالای به اتمام رسیده، محصول دیگری را جایگزین کند.
                <br />
                ۷-۴- با انصراف مشتری از خرید ، مبلغ پرداخت شده با کسر 5 درصد از
                مبلغ واریزی به عنوان هزینه های اداری و مالی طی ۲۴ الی ۴۸ ساعت کاری
                به حساب مشتری (اعلام شده از سوی مشتری از طریق ایمیل یا سایر راههای
                ارتباطی و صرفا اعلام کتبی ) واریز خواهد شد.
                <br />
                ۸-۴- در صورت بروز هرگونه خطا نسبت به درج قیمت و ارزش ریالی کالاهای
                موجود در سایت پیکان پارس ، حق بلا اثر نمودن سفارش و خرید انجام شده
                توسط مشتری، برای پیکان پارس محفوظ است. بدیهی است پیکان پارس در
                اسرع وقت وجه دریافتی را به پرداخت کننده طی ۲۴ الی ۴۸ ساعت کاری به
                حساب اعلام شده توسط مشتری(اعلام شده از سوی مشتری از طریق ایمیل یا
                سایر راههای ارتباطی و صرفا اعلام کتبی) واریز و عودت می‌نماید و
                مشتری با خرید از سایت پیکان پارس از این امر و کلیه قوانین آگاهی
                داشته و در این خصوص ادعایی نخواهد داشت.
                <br />
                ۹-۴- با توجه به ثبت سیستمی سفارش، به هیچ عنوان امکان صدور فاکتور
                مجدد یا تغییر مشخصات آن از جمله تغییر فاکتوری که به نام شخص حقیقی
                صادر شده، به نام شخص حقیقی دیگری وجود ندارد.
                <br />
                ۱۰-۴- از آنجا که پیکان پارس یک وب ‌سایت کلی فروشی آنلاین است،
                سفارش یک کالا یا چند کالا به تعداد یک عدد به شرط مصرف خریدار
                نهایی، مغایر با هدف پیکان پارس است، در صورت ثبت این مورد و یا
                سفارشاتی که با این تعداد اقلام همراه هستند، حق کنسل کردن آن سفارش
                توسط پیکان پارس محفوظ است.
                <br />
                ۱۱-۴- لازم به ذکر است افزودن کالا به سبد خرید به معنی رزرو کالا
                نیست و هیچ گونه حقی را برای مشتریان ایجاد نمی‌کند. همچنین تا پیش
                از ثبت نهایی، هرگونه تغییر از جمله تغییر در موجودی کالا یا قیمت،
                روی کالای افزوده شده به سبد خرید اعمال خواهد شد. بنابراین به
                مشتریانی که تمایل و تصمیم به خرید قطعی دارند، به‌ویژه درباره
                کالاهای در زمان فروش ویژه یا جشنواره که دارای محدودیت تعداد هستند،
                توصیه می‌شود در اسرع وقت سفارش خود را نهایی کنند تا با اتمام
                موجودی یا تغییر قیمتی کالاها روبرو نشوند. شایان ذکر است سفارش تنها
                زمانی نهایی می‌شود که کاربران کد رهگیری نهایی تکمیل سفارش خود را
                از طریق ایمیل دریافت کنند و بدیهی است که پیکان پارس هیچ‌گونه
                مسوولیتی نسبت به کالاهایی که در سبد خرید رها شده است یا پروسه
                سفارش تکمیل نشده و تکمیل وجه نشده ، ندارد.
                <br />
                پس از تایید نهایی فاکتور توسط کاربر سایت و پیکان پارس ، طریقه
                ارسال از طریق سایت اطلاع رسانی خواهد شد و بعد از ان فاکتور تایید
                شده به منزله دریافت شده توسط مشتری لحاظ میشود در این صورت کاربر
                موظف به بررسی عملیات و روریه ارسال که در سایت اطلاع رسانی شده می
                باشد و هرگونه مغایرت احتمالی در ارسال را حداکثر در سه روز کاری به
                اطلاع پیکان پارس برساند و بعد از ان هیچ گونه مسولیتی متوجه پیکان
                پارس نخواهد بود.
                <br />
                پس از دریافت مرسوله ارسالی کاربر موظف به بررسی فاکتور نهایی با
                اجناس دریافت شده می باشد و هرگونه مغایرت احتمالی را حداکثر در 3
                روز کاری به اطلاع پیکان پارس برساند در غیر این صورت خسارت یا هزینه
                ای متوجه پیکان پارس نخواهد بود. (با توجه به بررسی فاکتور ها در دو
                مرحله و به صورت سیستمی امکان خطا از طرف پیکان پارس با توجه به گردش
                کالا بسیار نا چیز و تقریبا صفر می باشد، بدیهی است با اطلاع از این
                مطلب مشتریان و کاربران پس از حصول اطمیان 100 درصدی از نقصان موجود
                اطلاع رسانی کنند)
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۵- روشهای پرداخت
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                ۱-۵- مشتریان می توانند وجه سفارش خود را بصورت آنلاین، کارت به کارت
                یا پرداخت در محل برای مشتریان بومی (بصورت کارت بانکی و از طریق
                دستگاه پوز) پرداخت نمایند.
                <br />
                ۲-۵- مشتریان که به صورت چکی خرید انجام داده اند، پس از ارسال چک
                مربوطه و تایید نهایی توسط پیکان پارس پرداخت آن ها نهایی خواهد شد.
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۶- روشهای ارسال سفارش
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                ۱-۶- سفارشات در شهر مشهد صرفا توسط پیک های مجاز و وانت بار های مورد
                تایید پیکان پارس و اسنپ ارسال می گردد.
                <br />
                ۲-۶- در سایر شهرهای سفارش ها علاوه بر پست یا تیپاکس، توسط شرکت های
                باربری مجاز و تعیین شده توسط مشتری ارسال می گردند.
            </Typography>
            <Typography variant="h5" fontSize={18} gutterBottom>
                ۷- ضمانت و مرجوعی اجناس
            </Typography>
            <Typography fontSize={16} gutterBottom color="text.secondary">
                تمامی کالا ها و اجناس موجود در پیکان پارس به دو بخش سازنده داخلی و
                خارجی تقسیم میشود .
                <br />
                در مورد سازنده خارجی با توجه به برند بودن و شناخته شدن محصول آن
                برند و تاییده اصالت کالای تولید شده ، هیچ گونه ضمانت و مرجوعی شامل
                آن کالا نمی باشد (تمامی اشکالات، خطاهای فنی و ایرادها مربوطه به نا
                آگاهی یا اشتباه فردی می باشد ). بدیهی است با اطلاع از این موضوع
                هرگونه برگشت کالا با برند خارجی به پیکان پارس ممنوع می باشد و
                همچنین هیچ خسارت و هزینه ای متوجه پیکان پارس نخواهد بود .
                <br />
                در مورد کالاهای تولید داخل ضمانت منوط به تایید سازنده یا بسته بندی
                کننده قطعه می باشد و پیکان پارس پس از دریافت کالا مرجوعی طی مدت
                حداکثر 1 ماه نتیجه بررسی کالای برگشتی را به مشتری اعلام می نماید.
                بدیهی است در صورت عدم تایید ازطرف شرکت سازنده هیچ گونه خسارت و
                هزینه ای متوجه پیکان پارس نخواهد بود
            </Typography>
        </Box>
    )
}

